export default {
  OPEN: "open",
  Rr: "purchase",
  kr: "push_click",
  ve: "custom_event",
  Ao: "iam_click",
  Xt: "test",
};
